import Chip from "@material-ui/core/Chip/Chip";
import { makeStyles } from "@material-ui/styles";
import FeatherIcon from "feather-icons-react";
import React from "react";

interface Props {
  handleDelete?: (value) => any | null;
  data: any;
  dark?: boolean;
  icon?: string;
  selectedChips?: any;
}

const useStyle = makeStyles(() => ({
  deleteDark: {
    color: "#6DA6F2",
    width: 12,
  },
  deleteLight: {
    color: "#b8d3f8",
    width: 12,
  },
  deleteGreen: {
    color: "white",
    width: 12,
  },
  chipDark: {
    margin: 4,
    background: "#b8d4f9",
    borderRadius: 4,
    color: "#0066B3",
    fontSize: 12,
    fontWeight: 500,
  },
  chipLight: {
    margin: 4,
    background: "#6da8f3",
    borderRadius: 4,
    color: "white",
    fontSize: 12,
    fontWeight: 500,
  },
  chipGreen: {
    margin: 4,
    background: "#27AE60",
    borderRadius: 4,
    color: "white",
    fontSize: 12,
    fontWeight: 500,
    "&:focus": {
      background: "#27AE60",
    },
  },
}));

const ChipElement = ({
  handleDelete = undefined,
  data,
  dark = true,
  icon = "",
  selectedChips = [],
}: Props) => {
  const classes = useStyle();
  return (
    <Chip
      classes={{
        deleteIcon: selectedChips.filter((chip) => chip.label === "")
          ? classes.deleteGreen
          : dark
          ? classes.deleteDark
          : classes.deleteLight,
      }}
      label={data.label}
      onDelete={handleDelete ? handleDelete(data) : null}
      className={
        selectedChips.some((e) => e.key === data.key)
          ? classes.chipGreen
          : dark
          ? classes.chipDark
          : classes.chipLight
      }
      deleteIcon={
        <FeatherIcon
          icon={
            selectedChips.some((e) => e.key === data.key)
              ? "check"
              : icon || "x"
          }
          size={7}
        />
      }
    />
  );
};

export default ChipElement;
